import { DecorationType, Editor } from 'slate';

export function hasMark(editor: Editor, type: DecorationType) {
    return Editor.marks(editor)?.[type];
}
